<va-card *ngIf="showCard()" class="help-case-card">
  <ng-container *ngIf="helpCase.id === 'liveChat'; else helpCard">
    <div class="help-case-card_inner-container" onclick="$zopim.livechat.window.show()">
      <div class="help-image-container">
        <div>
          <img [src]="getImageSrc(helpCase.image)" [alt]="helpCase.imageAlt" />
        </div>
      </div>
      <div class="help-name-container">
        <div class="help-name">
          {{ helpCase.name | translate }}
        </div>
      </div>
    </div>
  </ng-container>
  <ng-template #helpCard>
    <div class="help-case-card_inner-container">
      <div class="help-image-container">
        <div>
          <img [src]="getImageSrc(helpCase.image)" [alt]="helpCase.imageAlt" />
        </div>
      </div>
      <div class="help-name-container">
        <ng-container *ngIf="phone$ | async as phone; else helpNameNoPhone">
          <div class="help-name">
            {{ helpCase.name | translate }}
            <a href="tel:{{ phone }}">
              {{ phone | formatPhoneNumber : countryCode }}
            </a>
          </div>
        </ng-container>
        <ng-template #helpNameNoPhone>
          <div class="help-name">
            {{ helpCase.name | translate }}
            <glxy-badge *ngIf="helpCase.newBadge" [color]="'blue'" class="help-new-badge">
              {{ 'HELP_CENTER.NEW' | translate }}
            </glxy-badge>
          </div>
          <div class="help-sub-title">
            {{ helpCase.subTitle | translate }}
          </div>
        </ng-template>
      </div>
    </div>
  </ng-template>
</va-card>
